import { createReducer, on } from '@ngrx/store';
import * as CreditActions from '../actions/credits.actions';
export interface State {
    credits: any;
    errorMessage: string | null;
    isLoading: boolean;
}
export const initialState: State = {
    credits: 0,
    errorMessage: null,
    isLoading: false
};
export const creditsReducer = createReducer(
    initialState,

    on(CreditActions.loadUserCredits, (state) => ({
        ...state,
        isLoading: true,
        errorMessage: null
    })),

    on(CreditActions.loadUserCreditsSuccess, (state, { credits }) => ({
        ...state,
        credits: credits["balance"],
        isLoading: false,
        errorMessage: null
    })),

    on(CreditActions.loadUserCreditsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        errorMessage: error
    })),


);